import ScrollToTop from "react-scroll-to-top";
export function BackToTop(){
 

    return <>
      <ScrollToTop height="16" color="white" style={{marginBottom:'10vh',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',backgroundColor:'rgb(109 40 217)'}} smooth />
    
    </>
}